document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.collection-thc-slider__slides', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: false,
    grabCursor: true,
    keyboard: { enabled: true },
    a11y: { enabled: true },
    watchOverflow: true,
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20
      }
    }
  });
});
